import React from "react";

import { DEAL_TYPE_KEYS } from "@frontend/common";

import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealsKeyCommentMaCreatorTable from "./components/DealsKeyCommentMaCreatorTable/DealsKeyCommentMaCreatorTable";
import { DEALS_MA_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT } from "./constants/dealsKeyCommentGroupTableLayout";
import * as S from "./DealsKeyCommentGroupTable.style";

const groupTableIndex = 3;

const maLayout = DEALS_MA_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT;

const DealsKeyCommentGroupTable = () => {
  const { isMergeAndAcquisition, isVentureFormation, currentDealTypeList } =
    useCurrentDealTypeValue();
  const { register } = useScroll();
  const { tableCount } = useGetNumberOfTable();
  const articleSection = useArticleSection();

  const { checkDisableEdit } = useCanEditGroupTable();

  // NOTE: V2(LA&SC)로 이관되지 않은 M&A·순수 Venture Formation(VF && !LA) 만 V1 Key Comment 를 렌더한다.
  // VF+LA 를 포함한 그 외 카테고리는 DealLaScKeyCommentGroupTable(V2)가 담당한다.
  const isPureVentureFormation =
    isVentureFormation &&
    !currentDealTypeList.includes(DEAL_TYPE_KEYS.licenseAgreement);

  if (!isMergeAndAcquisition && !isPureVentureFormation) return null;

  // M&A·순수 VF 는 동일한 "Key Comment List"(복수) 구조를 쓴다.
  const { groupTableKey } = maLayout;

  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register(groupTableKey)}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {newArrayToCountValue(tableCount(groupTableKey)).map(
          (_, tableIndex) => (
            <DealsKeyCommentMaCreatorTable
              key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
              tableKey={maLayout.tableList[0].tableKey}
              groupShellList={maLayout.tableList[0].groupShellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableIndex={tableIndex}
            />
          ),
        )}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealsKeyCommentGroupTable;
